<template>
  <div>
    <grid-cell-image :col="column" :value="value" v-if="value" css="full"></grid-cell-image>
    <q-btn
      color="primary"
      class="uploader-box q-pa-md"
      flat text-color="primary"
      align="center"
      icon="add_a_photo"
      label="Select Image"
      @click="triggerSelect"
      v-if="!value && !column.component.props.multiple"
    ></q-btn>
    <div class="q-ma-sm" v-show="value && apiEndpoint">
      <q-uploader
        ref="uploadwidget"
        :url="apiEndpoint"
        method="POST"
        :multiple="!!column.component.props.multiple"
        :headers="headers"
        :hide-upload-button="true"
        :hide-upload-progress="true"
        :additional-fields="additionalFields"
        :auto-expand="true"
        :clearable="true"
        align="center"
        name="image"
        extensions=".gif,.jpg,.jpeg,.png"
        hide-underline
        @uploaded="handleUploadComplete"
        @fail="handleFail"
        @add="handleAdd"
        @remove:abort="handleRemove"
        @remove:cancel="handleRemove"
      ></q-uploader>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageUploadField',
  props: {
    resource: String,
    column: Object,
    value: {
      default: () => ''
    },
    modelId: null
  },
  data () {
    return {
      error: null,
      cloudinaryWidget: null,
      theModelId: this.modelId,
      userAddedFile: false,
      model: {}
    }
  },
  computed: {
    apiEndpoint () {
      const baseUrl = process.env.API_URL
      return `${baseUrl}${this.$store.state[this.resource].apiEndpoint}/upload`
    },
    headers () {
      return {
        Authorization: `Bearer ${this.$store.getters['user/token']}`,
        brandId: this.$store.getters['selectedAdmin'].id
      }
    },
    additionalFields () {
      return [
        {
          name: 'field',
          value: this.column.field
        },
        {
          name: 'id',
          value: this.theModelId
        }
      ]
    }
  },
  methods: {
    triggerSelect () {
      this.$refs.uploadwidget.$refs.file.click()
    },
    triggerUpload (params) {
      if (!this.userAddedFile) {
        return this.$emit('async-complete', this.column)
      }
      if (this.value) {
        // console.log('>> init upload', params)
        const {id, model} = params
        if (id) {
          this.theModelId = id
        }
        if (model) {
          this.model = model
        }
        this.$emit('async-init', this.column)
        this.$nextTick(() => {
          this.$refs.uploadwidget.upload()
        })
      } else {
        this.$emit('async-complete', this.column)
      }
    },
    handleUploadComplete (file, xhr) {
      // console.log('COMPLETE!')
      // console.log('file', file)
      // console.log('xhr', xhr)
      // console.log('async-complete', this.column)
      this.$emit('async-complete', this.column)
    },
    handleAdd (files) {
      this.userAddedFile = true
      if (this.column.component.multiple) {
        this.$emit('input', files)
      } else {
        this.$emit('input', files[0])
      }
    },
    handleRemove (file) {
      this.userAddedFile = false
      // console.log('file', file)
      this.$emit('input', '')
    },
    handleFail (file, xhr) {
      // console.log('FAIL')
      // console.log('file', file)
      // console.log('xhr', xhr)
    }
  },
  created () {
    this.$root.$on('trigger_upload', this.triggerUpload)
  },
  beforeDestroy () {
    this.$root.$off('trigger_upload', this.triggerUpload)
  }
}
</script>
<style lang="stylus" scoped>
  .uploader-box
    border 1px dashed
    width 100%

  .q-input-target
    display none !important
</style>
